<template>
  <LoadingSpinner :loading="loading" />
  <div v-if="!loading" class="m-4">
    <h2>{{ $t('titre.ListOfMovement') }}</h2>
    <!-- Toolbar Menu -->
    <div class="toolbar">
      <button class="btn btn-primary" @click="navigateToEntry()">Add Incoming</button>
      <button class="btn btn-secondary" @click="navigateToExit()">Add Outgoing</button>
      <!--button class="btn btn-success" @click="exportData">Export</button-->
      <select v-model="filters.e_s" @change="applyFilters" class="filter-List" value="in">
        <option value="in">Incoming</option>
        <option value="out">Outgoing</option>
      </select>
    </div>

    <table class="custom-table">
      <thead>
        <tr>
          <th>
            <input v-model="filters.date" placeholder="Filter Date" @input="applyFilters" class="filter-input" />
          </th>
          <th>
            <input v-model="filters.nombre" placeholder="Filter Nombre" @input="applyFilters" class="filter-input" />
          </th>
          <th>
            <input v-model="filters.poidTot" placeholder="Filter Total en Kg" @input="applyFilters"
              class="filter-input" />
          </th>
          <th>
            <input v-model="filters.prixTot" placeholder="Filter Total Prix" @input="applyFilters"
              class="filter-input" />
          </th>
          <th>
            <input v-if="filters.e_s === 'in'" v-model="filters.source" placeholder="Filter Source"
              @input="applyFilters" class="filter-input" />
            <input v-else v-model="filters.destination" placeholder="Filter Destination" @input="applyFilters"
              class="filter-input" />
          </th>
          <th>
            <input v-model="filters.weightPerUnit" placeholder="Filter Weight/Unit" @input="applyFilters"
              class="filter-input" />
          </th>
          <th>
            <input v-model="filters.pricePerUnit" placeholder="Filter Price/Unit" @input="applyFilters"
              class="filter-input" />
          </th>

          <th></th>
        </tr>
        <tr>
          <th>Date</th>
          <th>Nombre</th>
          <th>Total en Kg</th>
          <th>Total Prix</th>
          <th v-if="filters.e_s === 'in'">Source</th>
          <th v-else>Destination</th>
          <th>Weight per Unit</th>
          <th>Price per Unit</th>
          <!--th>Remarque</th-->
          <!--th>DateSys</th-->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loop through the merged rows (data + details) -->
        <!--tr v-for="(row, index) in rowsWithDetails" :key="index"-->
        <tr v-for="(row, index) in rowsWithDetails" :key="index">
          <td class="col-md-1" v-if="row.type === 'data'">{{ row.date }}</td>
          <td class="col-md-1" v-if="row.type === 'data'">{{ row.nombre }}</td>
          <td class="col-md-2" v-if="row.type === 'data'">{{ row.poidTot }}</td>
          <td class="col-md-2" v-if="row.type === 'data'">{{ formatPrice(row.prixTot) }}</td>
          <td class="col-md-2" v-if="row.type === 'data'">{{ row.e_s === 'in' ? row.source : (row.e_s === 'out' ?
            row.destination : null ) }}</td>
          <td class="col-md-1" v-if="row.type === 'data'">{{ row.nombre ? (row.poidTot / row.nombre).toFixed(2) : 0 }}
          </td>
          <!--td class="col-md-1" v-if="row.type === 'data'">{{ row.poidTot ? formatPrice((row.prixTot / row.poidTot).toFixed(2)) : 0 }}</td-->
          <td class="col-md-1" v-if="row.type === 'data'">{{ row.poidTot ? formatPrice((row.totalPrix /
            row.poidTot).toFixed(2)) : 0 }}</td>
          <td class="col-md-2" v-if="row.type === 'data'">
            <div class="btn-edit-delete">
              <button class="btn btn-outline-primary btn-sm me-2" type="submit"
                @click="editMovement(row.id, row.source, row.destination)">
                <i class="fas fa-edit"></i> {{ row.id ? $t('') : $t('') }}
              </button>
              <button class="btn btn-outline-danger me-2 btn-sm" @click="deleteMovement(row.id)">
                <i class="fas fa-trash"></i> {{ $t('') }}
              </button>
              <button @click="toggleDetails(row.index)" class="btn btn-outline-success btn-sm me-2">
                <i class="bi bi-eye"></i>{{ row.showDetails ? '' : '' }}
              </button>
            </div>
          </td>

          <!-- Render details row -->
          <td v-if="row.type === 'details'" colspan="8">
            <!-- Use the MovementDisplay component -->
            <MovementDisplay :movement="row" />
            <!--div class="details-content">
                <p><strong>Additional Details:</strong></p>
                <p>Details for item with Date: {{ row.date }}</p>
                <p>Additional information about the item can be added here.</p>
                <p></p>
              </div-->
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>Total</td>
          <td>{{ totalNombre }}</td>
          <td>{{ totalPoidTot }}</td>
          <td>{{ formatPrice(totalPrixTot) }}</td>
          <td></td>
          <td>{{ totalNombre ? (totalPoidTot / totalNombre).toFixed(2) : 0 }}</td>
          <td>{{ totalPoidTot ? formatPrice((totalPrixTot / totalPoidTot).toFixed(2)) : 0 }}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <div class="pagination">
      <button @click="goToPage(1)" :disabled="currentPage === 1">« First</button>
      <button @click="prevPage" :disabled="currentPage === 1">❮</button>
      <span> Page {{ currentPage }} of {{ totalPages }} </span>
      <button @click="nextPage" :disabled="currentPage === totalPages">❯</button>
      <button @click="goToPage(totalPages)" :disabled="currentPage === totalPages">Last »</button>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { MovementService } from '../api';
import { Message } from "../libjs/alertService"; // Adjust the path
import Movement from '../model/Movement';
import LoadingSpinner from "@/components/LoadingSpinner.vue"; // Import the new component
import MovementDisplay from "./ListOfMovementBySelected.vue"; // Import the reusable component

export default {
  components: { LoadingSpinner, MovementDisplay },
  data() {
    return {
      items: [],
      movementData: new Movement(),
      filters: {
        date: "",
        nombre: "",
        poidTot: "",
        prixTot: "",
        source: "",
        destination: "",
        remarque: "",
        dateSys: "",
        weightPerUnit: "",
        pricePerUnit: "",
        e_s: "in"
      },
      loading: true, // Set initial loading state to true
      // Pagination
      currentPage: 1,
      pageSize: 10, // Number of rows per page
    };
  },
  computed: {
    paginatedItems() {
      //const start = (this.currentPage - 1) * this.pageSize;
      //return this.filteredItems.slice(start, start + this.pageSize);
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.pageSize);
    },
    filteredItems() {
      return this.items.filter((item) => {
        return (
          (this.filters.date === "" || item.date.includes(this.filters.date)) &&
          (this.filters.dateSys === "" || item.dateSys.includes(this.filters.dateSys)) &&
          (this.filters.nombre === "" || item.nombre.toString().includes(this.filters.nombre)) &&
          (this.filters.poidTot === "" || item.poidTot.toString().includes(this.filters.poidTot)) &&
          (this.filters.prixTot === "" || item.prixTot.toString().includes(this.filters.prixTot)) &&
          (this.filters.source === "" || item.source.toString().toLowerCase().includes(this.filters.source.toLowerCase())) &&
          (this.filters.destination === "" || item.destination.toString().toLowerCase().includes(this.filters.destination.toLowerCase())) &&
          (this.filters.remarque === "" || item.remarque.toString().toLowerCase().includes(this.filters.remarque.toLowerCase())) &&
          (this.filters.weightPerUnit === "" || (item.poidTot && item.nombre && (item.poidTot / item.nombre).toFixed(2).includes(this.filters.weightPerUnit))) &&
          (this.filters.pricePerUnit === "" || (item.prixTot && item.poidTot && (item.prixTot / item.poidTot).toFixed(2).includes(this.filters.pricePerUnit))) &&
          (this.filters.e_s === "" || item.e_s === this.filters.e_s) // Apply e_s filter here
        );
      });
    },
    rowsWithDetails() {
      const rows = [];
      this.paginatedItems.forEach((item, index) => {
        // Add the regular row
        rows.push({
          type: 'data',
          index: index,
          ...item,
        });

        // Add the details row if showDetails is true
        if (item.showDetails) {
          rows.push({
            type: 'details',
            // date: item.date,
            ...item,
          });
        }
      });
      return rows;
    },
    totalNombre() {
      return this.filteredItems.reduce((sum, item) => sum + item.nombre, 0);
    },
    totalPoidTot() {
      return this.filteredItems.reduce((sum, item) => sum + item.poidTot, 0);
    },
    totalPrixTot() {
      return this.filteredItems.reduce((sum, item) => sum + item.prixTot, 0);
    },
  },
  methods: {
    async fetchMovements() {
      try {
        this.loading = true
        const response = await MovementService.listMovement();
        this.items = response;
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Error fetching data:', error);
      }
    },
    async deleteMovement(id) {
      try {
        await MovementService.deleteMovement(id);
        this.fetchMovements();
        Message("success", this.$t("message.delete_success"));
      } catch (error) {
        Message("danger", this.$t("message.delete_failed"));
      }
    },
    async editMovement(id, source, destination) {
      try {
        //const data  = await MovementService.getMovement(id);
        //console.log('data ' + JSON.stringify(data))
        //this.movementData = data
        //console.log('movementData ' + JSON.stringify(this.movementData))
        //Redirection
        this.setMovementId(id)
        console.log('before redirection')
        console.log('-1-> ' + (source !== null && destination === null))
        if (source !== null && destination === null) {
          console.log('incoming')
          this.$router.push({ path: '/incoming' });
        }
        console.log('-2-> ' + (source === null && destination !== null))
        if (source === null && destination !== null) {
          console.log('outgoing')
          this.$router.push({ path: '/outgoing' });
        }
        //this.$router.push({ path: '/incoming'});
        //Message("success", this.$t("message.delete_success"));
      } catch (error) {
        Message("danger", this.$t("message.delete_failed"));
      }
    },
    // Helper method to get the 'value' from 'source'
    getSourceValue(source) {
      return source ? source : "";
    },
    // Helper method to get the 'value' from 'source'
    getDestinationValue(destination) {
      return destination ? destination : "";
    },
    applyFilters() {
      // This is automatically handled by v-model and computed property
    },
    toggleDetails(index) {
      // Toggle the 'showDetails' flag for the selected item
      this.filteredItems[index].showDetails = !this.filteredItems[index].showDetails;
    },
    navigateToEntry() {
      this.$router.push({ path: '/incoming' });
    },
    navigateToExit() {
      //this.$router.push({ path: '/outgoing'});MovementOut
      this.$router.push({ path: '/MovementOut' });
    },
    exportData() {
      console.log('Exporting data...');
    },
    formatPrice(value) {
      if (!value) return "0 €";
      return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2
      }).format(value);
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) this.currentPage = page;
    },
    ...mapMutations(['setMovementId'])
  },
  mounted() {
    this.fetchMovements();
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0px;
  border-radius: 10px;
}

h2 {
  background-color: #47c399;
  border-radius: 10px 10px 0 0;
  color: azure;
  padding: 3px;
  text-align: justify;
  padding-left: 15px;
}

/* Table Styles */
.toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Arial", sans-serif;
  font-size: 14px;
  margin-top: 20px;
}

.custom-table thead tr {
  background-color: #f2f2f2;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 4px 6px;
  text-align: center;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:hover {
  background-color: #f1f1f1;
}

.custom-table tfoot tr {
  background-color: #b9d3f7;
  font-weight: bold;
}

.custom-table tfoot td {
  padding: 6px;
  text-align: center;
}

/* Filter Input Styling */
.filter-input {
  width: 100%;
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  box-sizing: border-box;
}

/* Header Styling */
.custom-table th {
  background-color: #f9fafb;
  /*#5585b9;*/
  color: rgb(12, 0, 0);
  text-transform: uppercase;
  font-weight: bold;
}

/* Button Styles */
.edit-btn,
.delete-btn,
.details-btn {
  padding: 3px 8px;
  border: none;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
}

.edit-btn {
  background-color: #007bff;
  color: white;
  margin-right: 5px;
  transition: background-color 0.3s ease;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
  transition: background-color 0.3s ease;
}

.details-btn {
  background-color: #28a745;
  color: white;
  transition: background-color 0.3s ease;
}

.edit-btn:hover {
  background-color: #0056b3;
}

.delete-btn:hover {
  background-color: #c82333;
}

.details-btn:hover {
  background-color: #218838;
}

/* Details Content */
.details-content {
  background-color: #f9f9f9;
  padding: 10px;
  border: 1px solid #ddd;
  /*margin-top: 1px;*/
}

.btn {
  position: relative;
  font-size: 10px;
  font-weight: bold;
}

.filter-list[data-v-0a350714] {
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  box-sizing: border-box;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.pagination button {
  padding: 5px 10px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 3px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>